module.exports = __webpack_public_path__ + "static/media/calender.2f222e43.svg";